import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';
import head from 'lodash/head';
import find from 'lodash/find';


import * as c from '../constants';


const getHotkeyTmpState = createSelector(
  [
    (state) => state.hotkey_template
  ],
  (state) => state
);


export const getTabState = createSelector(
  [
    getHotkeyTmpState
  ],
  (state) => state.tabs || {}
);


export const getTabLevel = createSelector(
  [
    getTabState
  ],
  (state) => state.level || 0
);


export const getTabList = createSelector(
  [
    getTabState
  ],
  (state) => state.list || {}
);


export const getLevelState = createSelector(
  [
    getTabLevel,
    getTabList
  ],
  (level, list) => list[level] || {}
);


export const getSelectedTab = createSelector(
  [
    getLevelState
  ],
  (tabs) => tabs.selected || {}
);


export const getSelectedTabKey = createSelector(
  [
    getSelectedTab
  ],
  (selected) => selected.key_level || null
);


export const getTabs = createSelector(
  [
    getLevelState
  ],
  (tabs) => tabs.items || []
);


export const getLevelAndTabs = createSelector(
  [
    getTabLevel,
    getTabs
  ],
  (level, tabs) => ({ level, tabs }) || []
);


export const getLevelAndSortedTabs = createSelector(
  [
    getTabLevel,
    getTabs
  ],
  (level, tabs) => ({
    level,
    tabs: sortBy(tabs, ['position']) || []
  })
);


export const getTabsAtLevel = createSelector(
  [
    (state, level) => getTabList(state),
    (state, level) => level
  ],
  (list, level) => (list[level] || {}).items || []
);


export const getSortedTabsAtLevel = createSelector(
  [
    getTabsAtLevel
  ],
  (tabs) => sortBy(tabs, ['position']) || []
)


export const getLevelSaveStatus = createSelector(
  [
    (state, level) => getTabList(state),
    (state, level) => level
  ],
  (list, level) => (list[level] || {}).saved || false
);


export const getParentForLevel = createSelector(
  [
    (state, level) => getTabsAtLevel(state, level - 1),
    (state, level) => getTabsAtLevel(state, level)
  ],
  (parentTabs, tabs) => {
    if (isEmpty(parentTabs)) {
      return null;
    }

    const { parent_id } = head(tabs) || {};

    if (isEmpty(parent_id)) {
      return null;
    }

    return find(parentTabs, { key: parent_id }) || null;
  }
);


export const getDefaultBreadcrumbs = createSelector(
  [
    getTabs
  ],
  (items) => {
    const { breadcrumbs } = find(items, { key: c.ADD_DOC_ID }) || {};
    return breadcrumbs || [];
  }
)
